import { fetchApps, fetchUsers, useData } from "./utils";

export const useUsers = () => useData(fetchUsers);
export const useApps = () => useData(fetchApps);
